import * as React from "react";
import { Pressable, ScrollView, StyleSheet, Linking, View } from "react-native";
import fixture from "./__test__/fixture.json";
import { Text, useTheme } from "react-native-paper";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { Block } from "@block";
import { StackActions, useNavigation } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { spacing } from "@styles/spacing";
import { useDesktopMediaQuery } from "@media-query";
import IconsYellowBanking from "app/shared/components/icons/icon-yellow-banking/IconsYellowBanking";
import { StackSpacing } from "@components/spacing";
import { globalShowFuture } from "app/shared/util/future";
import ScreenNameType from "app/shared/constant/nav-screen.type";
import Animated, { useAnimatedStyle, withSpring } from "react-native-reanimated";
import { pushAppFlyer } from "app/shared/util/app-flyer";

type PressAbleState = Readonly<{
  pressed: boolean;
  hovered?: boolean;
  focused?: boolean;
}>;

enum LINKS {
  TIM_ATM = 0,
  LAI_SUAT = 1,
  TI_GIA = 2,
  THE_GIOI_WOW = 3,
}

const ListUtilities = () => {
  const { colors, fonts } = useTheme();
  const { t, i18n } = useTranslation();
  const { dispatch, navigate } = useNavigation();
  const isDesktop = useDesktopMediaQuery();

  const onCancel = () => {
    console.log("ListPayments onCancel");
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => onCancel(),
    },
    {
      name: t("FUNC_TIEN_ICH"),
      onPressSubtitle: () => {},
    },
  ];

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        textName: { ...fonts.medium, color: colors.text, textAlign: "center", maxWidth: 164, alignSelf: "center" },
      }),
    [colors.text, fonts.medium],
  );

  const handlerParamsAppFlyer = (action: string) => {
    console.log("handlerParamsAppFlyer");
    return {
      eventName: "af_utilities",
      params: {
        af_channel: "ib_rb",
        af_utilities_info: action,
      },
    };
  };

  const onPressItems = (index: number | string) => {
    switch (index) {
      //atm_trans_office, interest_rate, exchange_rate, wow_world
      case LINKS.TIM_ATM:
        if (i18n.language === "vi") {
          Linking.openURL("https://www.pvcombank.com.vn/mang-luoi");
        } else {
          Linking.openURL("https://www.pvcombank.com.vn/network");
        }
        const data1 = handlerParamsAppFlyer("atm_trans_office");
        pushAppFlyer(data1.eventName, data1.params);
        break;
      case LINKS.LAI_SUAT:
        if (i18n.language === "vi") {
          Linking.openURL("https://www.pvcombank.com.vn/bieu-lai-suat");
        } else {
          Linking.openURL("https://www.pvcombank.com.vn/interest-rates");
        }
        const data2 = handlerParamsAppFlyer("interest_rate");
        pushAppFlyer(data2.eventName, data2.params);
        break;
      case LINKS.TI_GIA:
        if (i18n.language === "vi") {
          Linking.openURL("https://www.pvcombank.com.vn/ti-gia-ngoai-te");
        } else {
          Linking.openURL("https://www.pvcombank.com.vn/exchange-rate");
        }
        const data3 = handlerParamsAppFlyer("exchange_rate");
        pushAppFlyer(data3.eventName, data3.params);
        break;
      case LINKS.THE_GIOI_WOW:
        if (i18n.language === "vi") {
          Linking.openURL("https://www.pvcombank.com.vn/khuyen-mai/uu-dai-wow");
        } else {
          Linking.openURL("https://www.pvcombank.com.vn/promotion/wow-world");
        }
        const data4 = handlerParamsAppFlyer("wow_world");
        pushAppFlyer(data4.eventName, data4.params);
        break;
      default:
        globalShowFuture();
        break;
    }
  };

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("FUNC_TIEN_ICH")} subtitles={subtitlesArrays} />
        <Block pv={spacing.medium} ph={isDesktop ? "5%" : 0}>
          <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
            {fixture.funcitons[0].children.map((_item, _index) => (
              <View key={_index} style={[{ maxWidth: isDesktop ? "25%" : "50%", minWidth: isDesktop ? "25%" : "50%" }]}>
                <Pressable style={{ alignSelf: "center" }} onPress={() => onPressItems(_index)} key={_index}>
                  {({ hovered }: PressAbleState) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    const _buttonStyle = useAnimatedStyle(() => {
                      return {
                        justifyContent: "center",
                        alignItems: "center",
                        transform: [
                          {
                            scale: hovered ? withSpring(1.06) : withSpring(1),
                          },
                        ],
                      };
                    });
                    return (
                      <Animated.View style={_buttonStyle}>
                        <Block br={20} p={spacing.huge} bg={colors.backgroundForm} middle center>
                          <IconsYellowBanking name={_item.icon} size={64} />
                        </Block>
                        <StackSpacing size="small" />
                        <Text numberOfLines={2} style={styles.textName}>
                          {i18n.language === "vi" ? _item.name.vi : _item.name.en}
                        </Text>
                        <StackSpacing size="huge" />
                      </Animated.View>
                    );
                  }}
                </Pressable>
              </View>
            ))}
          </View>
        </Block>
      </ScrollView>
    </Block>
  );
};

export default ListUtilities;
